import React from "react";
import Box from "@mui/material/Box";

export default function AgentSuspendedPill() {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 88,
        minWidth: 88,
        height: 24,
        borderRadius: "50px",
        border: "1px solid #FA8C16",
        background: "#FFF7E6",
        boxSizing: "border-box",
        fontFamily: "Inter",
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1,
        color: "#405261",
        whiteSpace: "nowrap",
        flexShrink: 0,
      }}
    >
      Suspended
    </Box>
  );
}
